// react
import { useContext, useState } from 'react';

// types
import { Category } from '../../../@types';

// context
import { ContextProject } from '../../pages/Project/Project.context';

// hooks
import { useFetch } from '../../../hooks/useFetch';

// fields
import { Select, SelectProps } from '../Select/Select';

// props
export interface SelectCategoryProps extends Omit<SelectProps, 'options'> {
	fields?: string[];
	idsEnabled?: number[];
}

export const SelectCategory = ({
	fields = ['id', 'name'],
	idsEnabled,
	...props
}: SelectCategoryProps) => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// context
	const { project } = useContext(ContextProject);

	// state
	const [categories, setCategories] = useState<Category[]>([]);

	// fetch category
	useFetch({
		isEnabled: Boolean(project?.id),
		url: `${process.env.REACT_APP_API_URL}/categories?project=${project?.id}&fields=${fields.join(',')}&status=ACTIVE&orderBy=name&order=ASC`,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setCategories(res.data);
			}
		},
	});

	const optionsCategory = categories.map((category) => {
		return {
			disabled: idsEnabled ? !idsEnabled.includes(category.id) : false,
			label: category.name,
			MenuItemProps: {
				resource: category,
			},
			value: String(category.id),
		};
	});

	return <Select name="category" {...props} options={optionsCategory} />;
};
